import React from 'react';
import { connect } from 'react-redux';
import {
  BUILD_LINKS, BRAND_BUILD_LINKS, ASSIGN_LINKS, ASSIGNMENT_LINKS,
  LIBRARY_LINKS, BRAND_LIBRARY_LINKS, SETTINGS_LINKS, MANAGE_BRAND_LINKS, BRAND_SETTINGS_LINKS,
  CORPORATE_SETTINGS_LINKS,
  MANAGE_TRAINER_LINKS,
  MANAGE_NCEP_TRAINER_LINKS,
  MANAGE_PUSH_NOTIFICATION_LINKS, DOWNLOAD_LINKS,
  MANAGE_COMMUNITY_LINKS,
  MANAGE_BRAND_COMMUNITY_LINKS
} from '../../static-content';
import { COLORS } from '../../styles/colors'
import { Link } from "react-router-dom";

let SETS = {
  'build': BUILD_LINKS,
  'assign': ASSIGN_LINKS,
  'library': LIBRARY_LINKS,
  'settings': SETTINGS_LINKS,
  'manageBrands': MANAGE_BRAND_LINKS,
  'manageTrainers': MANAGE_TRAINER_LINKS,
  'manageNCEPTrainers': MANAGE_NCEP_TRAINER_LINKS,
  'manageCommunity': MANAGE_COMMUNITY_LINKS,
  'managePushNotifications': MANAGE_PUSH_NOTIFICATION_LINKS,
  'assignments': ASSIGNMENT_LINKS,
  'downloads': DOWNLOAD_LINKS
}
class NavigationTabs extends React.Component {
  state = {
    value: '/build/workout',
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { activeRoute, title, subtitle, description, hideTabs, currentUser,isMobile } = this.props;
   
   
    if (currentUser.user.type &&  currentUser.user.type.includes('brand')) {
      SETS.library = BRAND_LIBRARY_LINKS;
      SETS.build = BRAND_BUILD_LINKS;
      SETS.settings = BRAND_SETTINGS_LINKS;
      SETS.manageCommunity = MANAGE_BRAND_COMMUNITY_LINKS;
    }

    if (currentUser.user.type &&  currentUser.user.type.includes('corporate')) {
      SETS.settings = CORPORATE_SETTINGS_LINKS;
    }

    const links = SETS[this.props.set];
    

    return (
      <div>
        <h1>{title}</h1>
        {
          hideTabs ? null :
            <div style={{ width: '100%', borderBottom: '1px solid ' + COLORS.grey, paddingBottom: 6, marginBottom: 40 }}>
              {
                links.map((link, i) => (
                  <Link key={i} to={link.route} >
                    <span style={{
                      color: COLORS.black,
                      padding: 6,
                      marginRight: 25,
                      borderBottom: activeRoute === link.route ? '5px solid ' + COLORS.orange : ''
                    }}>
                      {link.text}
                    </span>
                  </Link>
                ))
              }
            </div>
        }
         { this.props.isNewBtn &&
          <div style={{ marginBottom:10 }}>
          <span onClick={this.props.onClick} style={{ 
            cursor: 'pointer', 
            marginBottom:10, 
            textAlign: 'right',
            display: 'block',
            color: COLORS.orange,
            fontSize: isMobile ? '20px' : '16px'}}>{this.props.newBtnTxt}</span>
          </div>
       }
        <h2>{subtitle}</h2>
        <p>
          {description}
        </p>
      </div>

    );
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser
  }
}

export default connect(mapStateToProps)(NavigationTabs);



// WEBPACK FOOTER //
// ./src/components/nav/NavigationTabs.js